// Component based on W3Schools React tutorial: https://www.w3schools.com/react/react_components.asp
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import "../css/Navbar.css";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="navbar">
      <div className="logo">
        <img src={`${process.env.PUBLIC_URL}/images/logo.jpeg`} alt="Oktoberfest Logo" />
      </div>
      <button onClick={toggleMenu} id="toggle-nav" type="button" aria-label="Toggle menu">
        {isMenuOpen ? (<p>&uarr;</p>) : (<p>&darr;</p>)}
      </button>
      <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
        <li><Link to="/" onClick={() => setIsMenuOpen(false)}>Home</Link></li>
        <li><Link to="/information" onClick={() => setIsMenuOpen(false)}>Information</Link></li>
        <li><Link to="/tickets" onClick={() => setIsMenuOpen(false)}>Tickets</Link></li>
        <li><Link to="/about" onClick={() => setIsMenuOpen(false)}>About</Link></li>
        <li><Link to="/gallery" onClick={() => setIsMenuOpen(false)}>Gallery</Link></li>
        <li><Link to="/contact" onClick={() => setIsMenuOpen(false)}>Contact</Link></li>
      </ul>
    </nav>
  );
};

export default Navbar;
